import React from 'react';
import { Leaf, Snowflake, Heart, Sparkles, Cookie } from 'lucide-react';
import { FEATURES } from '@/data/products';

const ICONS = { Leaf, Snowflake, Heart, Sparkles, Candy: Cookie };

export default function FeatureBar({ compact = false }) {
  return (
    <section className="container-x py-10 lg:py-14" data-testid="feature-bar">
      <div className="glass-card rounded-3xl px-6 md:px-10 py-8 md:py-10">
        <div className={`grid gap-8 ${compact ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5'}`}>
          {FEATURES.map((f) => {
            const Icon = ICONS[f.icon] || Leaf;
            return (
              <div key={f.key} className="flex items-start gap-4 group" data-testid={`feature-${f.key}`}>
                <div className="shrink-0 w-12 h-12 rounded-full border border-gold/30 bg-gradient-to-b from-gold/10 to-transparent flex items-center justify-center group-hover:border-gold/70 transition-colors">
                  <Icon className="w-5 h-5 text-gold" />
                </div>
                <div className="min-w-0">
                  <h4 className="text-[12px] tracking-[0.22em] uppercase text-bone-100 font-semibold">{f.label}</h4>
                  <p className="text-[12.5px] text-bone-300/85 mt-1 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
